<template>
  <div class="card" :class="{ 'is-loading': isLoading }">
    <div v-if="isLoading">
      <spinner width="80" height="80" />
    </div>

    <div v-else-if="data.length > 0">
      <div class="header">
        <h3 class="title">
          {{ title }}
        </h3>
        <span class="subtitle">{{ subtitle }}</span>
      </div>

      <div class="grid-container">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="grid-item truncated"
          :style="{ backgroundColor: item.color }"
        >
          <el-tooltip
            placement="top"
            :content="tooltipContent(item.id, item.label)"
          >
            <span class="label">{{ item.label }}</span>
          </el-tooltip>
          <span class="percentage">{{ isPurcentage(item.value) }}</span>
        </div>
      </div>
    </div>
    <div v-else class="no-data">
      <span>
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'element-ui'
export default {
    name: 'InterestGrid',
    components: {
        'el-tooltip': Tooltip,
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: 'Title'
        },
        subtitle: {
            type: String,
            required: false,
            default: 'Based on 1st party customer data'
        },
        isCookieFirst: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: 'No distribution data available.'
        }
    },
    computed: {
        items() {
            const COLORS = ['#80D8FF', '#64B5F6', '#FFB74D', '#81D4FA', '#29B6F6', '#F06292', '#B388FF', '#26C6DA', '#64B5F6', '#FF7011']
            return [...(this.data || [])]
                .sort((a, b) => b.value - a.value)
                .map((item, index) => ({
                    label: item.name,
                    value: item.value,
                    id: item?.id,
                    color: COLORS[index % COLORS.length]
                }))
        }
    },
    methods: {
        isPurcentage(value) {
            if (this.title === 'User %') return `${value === 0 ? '0' : value < 0.1 ? '< 0.1' : value} %`
            return value
        },
        tooltipContent(id, label) {
            if (this.isCookieFirst && id) return `${id}: ${label}`
            return label
        }
    }
}
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  box-sizing: border-box;
  font-family: Arial, sans-serif;
}
.card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  padding: 15px;
  width: 100%;
  height: 100%;
  min-height: 712px;
  &.is-loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .no-data {
      width: 100%;
      height: 100%;
    }
}

.grid-item {
  width: 100%;
  height: 100%;
  min-width: 90px;
  min-height: 90px;
  max-width: 140px;
  max-height: 140px;
  aspect-ratio: 1 / 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: white;
  text-align: center;
  box-sizing: border-box;
  padding: 8px;
}

.label {
  display: block;
  text-align: center;
  width: 90px;
  font-size: 11px;
  margin-bottom: 4px;
  font-weight: 600;
  line-height: 1.1;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header {
  margin-bottom: 15px;
  .title {
    margin: 0;
    font-size: 1.25rem;
    color: #333;
  }
  .subtitle {
    margin: 0;
    font-size: 0.875rem;
    color: #9e9e9e;
  }
}

.percentage {
  font-size: 11px;
  font-weight: bold;
  opacity: 0.95;
}
@media (max-width: 1500px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    box-sizing: border-box;
    font-family: Arial, sans-serif;
  }

  .grid-item {
    width: 100%;
    height: 100%;
    min-width: 90px;
    min-height: 90px;
    max-width: 120px;
    max-height: 120px;
    aspect-ratio: 1 / 1;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    color: white;
    text-align: center;
    box-sizing: border-box;
    padding: 8px;
  }
}
</style>
